import { BaseReq, PaginationReq, PaginationResp, UpdaterResp } from "@/core/interface";
import { Moment } from "moment";

export class FollowBaseReq extends BaseReq {
  projectId: string | undefined = undefined; // 项目Id
  contacts: string = ""; //联系人
  contactType: string = ""; //联系方式
  cooperationCompanyId: string = ""; //联系对象 往来公司
  currentContactDate: string = ""; //本次联系时间
  nextCurrentContactDate: string = ""; // 下次联系时间
  remark: string = ""; //跟踪记录
}

export class FollowPageReq extends PaginationReq {
  name: string = ""; // 项目名称
  startContactDate: Moment; // 开始日期
  endContactDate: Moment; // 结束日期
  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class FollowDetailPageReq extends PaginationReq {
  projectId: string = ""; // 项目Id
  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class FollowListRecord extends UpdaterResp {
  id: string = "";
  bizNo: string = "";
  projectId: string | undefined = undefined; // 项目编号
  name: string = ""; // 项目名称
  cooperationCompanyId: string = ""; // 客户id
  cooperationCompanyName: string = ""; // 客户名称
  contactNum: number = 0; // 联系记录数
  currentContactDate: string = ""; // 最近联系日期
}

export class FollowPageResp extends PaginationResp<FollowListRecord> {}

export class FollowDetailRecord extends FollowListRecord {
  nextCurrentContactDate: string = "";
  contacts: string = "";
  contactType: string = "";
}

export class FollowDetailPageResp extends PaginationResp<FollowDetailRecord> {}
